import { isNumber } from 'lodash';
import PropTypes from 'prop-types';
import Button from '../Button';

const AddButton = ({
  isSelected,
  onAdd,
  onRemove,
  addLabel,
  removeLabel,
  buttonSize,
  doDiscardRadius,
  className,
  doShowLoadingState,
  disabled,
}) =>
  isSelected ? (
    <Button
      size={isNumber(buttonSize) ? buttonSize : Button.buttonSizes.SM}
      onClick={onRemove}
      doShowLoadingState={doShowLoadingState}
      variant={Button.buttonVariants.INLINE}
      doDiscardRadius={doDiscardRadius}
      className={className}
      disabled={disabled}
    >
      <span>{removeLabel}</span>
    </Button>
  ) : (
    <Button
      size={isNumber(buttonSize) ? buttonSize : Button.buttonSizes.SM}
      onClick={onAdd}
      doDiscardRadius={doDiscardRadius}
      className={className}
      doShowLoadingState={doShowLoadingState}
      disabled={disabled}
    >
      <span>{addLabel}</span>
    </Button>
  );

AddButton.propTypes = {
  addLabel: PropTypes.string.isRequired,
  removeLabel: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  buttonSize: PropTypes.number,
  doDiscardRadius: PropTypes.bool,
  className: PropTypes.string,
  doShowLoadingState: PropTypes.bool,
  disabled: PropTypes.bool,
};

AddButton.defaultProps = {
  isSelected: false,
  onAdd: () => {},
  onRemove: () => {},
  buttonSize: undefined,
  doDiscardRadius: false,
  className: undefined,
  doShowLoadingState: false,
  disabled: false,
};

export default AddButton;
